<!--給与振込口座申請-->
<template>
  <div>
    <div style="margin-top:10px">
      <div>
        <ul class="infinite-list decimal" style="font-size:13px">
          <!-- 口座は、従業員本人のものに限ります。親族、法人等名義の口座への振込はできません。(普通口座のみ)<br />
            ※別人の名義の口座は、見つけ次第削除いたしますので、再登録をして頂くタイミングによっては入金が遅れる事があります。 -->
          <li class="infinite-list-item" v-html="$t('MODULE.I0003_LBL_TEXT1')" />
          <!-- 登録された口座には、給与、立替経費、仮払金、還付金の振込を行い、それ以外の用途では使用しません。 -->
          <li class="infinite-list-item" v-html="$t('MODULE.I0003_LBL_TEXT2')" />
          <!-- 内容に変更があった場合は、すみやかに登録内容を修正してください。給与締め後の変更に関しては次回からの変更になる場合があります。 -->
          <li class="infinite-list-item" v-html="$t('MODULE.I0003_LBL_TEXT3')" />
        </ul>
      </div>
      <!-- 表头文字 -->
      <el-row :gutter="0">
        <!-- 支給情報 -->
        <div class="table-header">{{$t('MODULE.I0003_LBL_SUPPLY_INFO')}}</div>
      </el-row>
      <table class="i0003-table table-label">
        <tr>
          <!-- 銀行名 -->
          <td class="i0003-form-label">{{$t('MODULE.I0003_LBL_BANKNAME')}}</td>
          <td class="i0003-form-value">
            <el-autocomplete class="i0003-input" v-model="bankName" :fetch-suggestions="bankInput" value-key="bankName" @blur="bankBlur" :trigger-on-focus="false" @select="bankSelect">
            </el-autocomplete><span style="color:red">＊</span>
            <!-- ※入力した文字を含む銀行名が候補として表示されます。 -->
            {{$t('MODULE.I0003_LBL_TEXT4')}}
          </td>
        </tr>
        <tr>
          <!-- 支店名 -->
          <td class="i0003-form-label">{{$t('MODULE.I0003_LBL_BRANCHNAME')}}</td>
          <td class="i0003-form-value">
            <el-autocomplete class="i0003-input" v-model="branchName" :fetch-suggestions="branchInput" value-key="branchName" @blur="branchBlur" :trigger-on-focus="false" @select="branchSelect">
            </el-autocomplete><span style="color:red">＊</span>
            <!--  ※入力した文字を含む支店名が候補として表示されます。
            ※支店名のみの入力はできません。銀行名入力後に支店名を入力してください。 -->
            <span v-html="$t('MODULE.I0003_LBL_TEXT5')"></span>
          </td>
        </tr>
        <tr>
          <!-- 口座区分 -->
          <td class="i0003-form-label">{{$t('MODULE.I0003_LBL_ACCOUNT_CLASSIFICATION')}}</td>
          <td class="i0003-form-value">
            <!-- 普通 -->
            <template v-for="(item,key) in bankAccountDiv">
              <el-radio v-model="accountDiv" :label="item.key">{{item.value}}</el-radio>
            </template>
          </td>
        </tr>
        <tr>
          <!-- 口座番号 -->
          <td class="i0003-form-label">{{$t('MODULE.I0003_LBL_ACCOUNT_NUMBER')}}</td>
          <td class="i0003-form-value">
            <el-input class="i0003-input" v-model="accountNo" pattern="\d*" :maxlength="7" @input="accountNoChange"></el-input><span style="color:red">＊</span>
          </td>
        </tr>
        <tr>
          <!-- 名義人名 -->
          <td class="i0003-form-label">{{$t('MODULE.I0003_LBL_NOMINAL_NAME')}}</td>
          <td class="i0003-form-value">
            <el-input class="i0003-input" v-model="holderName"></el-input><span style="color:red">＊</span>
          </td>
        </tr>
        <tr>
          <!-- 名義人カナ -->
          <td class="i0003-form-label">{{$t('MODULE.I0003_LBL_NOMINAL_KANA')}}</td>
          <td class="i0003-form-value">
            <el-input class="i0003-input" v-model="holderKana" @input="holderKanaChange"></el-input><span style="color:red">＊</span>
            <!-- ※半角で入力ください。 -->
            {{$t('MODULE.I0003_LBL_TEXT6')}}
          </td>
        </tr>
      </table>
      <el-row v-show="processCd" style="font-size:13px;padding-top:5px">
        <!-- ステータス -->
        <span>{{statusName}}</span>
        <!-- 申請日時 -->
        <span v-if="status=='0'">{{applyDate}}</span>
        <!-- 確認日時 -->
        <span v-else>{{confirmDate}}</span>
      </el-row>
      <!-- 申請按钮 -->
      <div style="text-align:center">
        <el-button class="css-btn css-button" :disabled="processCd=='1'&&status=='2'" style="margin-top: 8px;font-size: 10pt;width:20%" type="primary" @click="apply">{{$t('MODULE.I0003_LBL_APPLY')}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import css from "@/statics/css"
import * as amsApi from "../api/i_0003"
import utilsApi from '../../common/utils'
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  data() {
    return {
      userCd: '',
      accountDiv: '1',//口座区分
      accountNo: '',//口座番号
      applyDate: '',//申請日時
      bankCd: '',//銀行コード
      bankName: '',//銀行名
      branchCd: '',//支店コード
      branchName: '',//支店名
      holderKana: '',//名義人カナ
      holderName: '',//名義人名
      id: '',//申請番号
      status: '',//ステータス
      statusName: '',//ステータス名
      processCd: '',//処理区分
      bankInfo: [], //銀行候補
      branchInfo: [],//支店候補
      bankAccountDiv: [],//口座区分
      confirmDate: '',//確認日時
      updateDate: '',//更新日時
    }
  },
  created() {
    this.search()
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
  },

  methods: {
    // 口座区分の内容を取得する。
    search() {
      let page = 'all'
      let div = '50'
      let type = 'bank_account_div'
      amsApi.conditionSearch(page, div, type).then(res => {
        this.bankAccountDiv = res.items.generalData.bankAccountDiv
        this.salaryAccountInfoQuery()
      })
    },

    // 給与振込口座申請検索
    salaryAccountInfoQuery() {
      this.set_loading()
      amsApi.salaryAccountInfoGet(this.userCd).then(res => {
        this.accountDiv = res.items.salaryAccountInfo.accountDiv//口座区分
        this.accountNo = res.items.salaryAccountInfo.accountNo//口座番号
        this.applyDate = utilsApi.extractMillisecond(res.items.salaryAccountInfo.applyDate)//申請日時
        if (this.applyDate) {
          this.applyDate = this.applyDate.replace(/\-/g, '/')
        }
        this.bankCd = res.items.salaryAccountInfo.bankCd//銀行コード
        this.bankName = res.items.salaryAccountInfo.bankName//銀行名
        this.branchCd = res.items.salaryAccountInfo.branchCd//支店コード
        this.branchName = res.items.salaryAccountInfo.branchName//支店名
        this.holderKana = res.items.salaryAccountInfo.holderKana//名義人カナ
        this.holderName = res.items.salaryAccountInfo.holderName//名義人名
        this.id = res.items.salaryAccountInfo.id//申請番号
        this.status = res.items.salaryAccountInfo.status//ステータス
        this.statusName = res.items.salaryAccountInfo.statusName//ステータス
        this.processCd = res.items.salaryAccountInfo.processCd//処理区分
        if (this.confirmDate) {
          this.confirmDate = this.confirmDate.replace(/\-/g, '/')
        }
        this.updateDate = res.items.salaryAccountInfo.updateDate
        this.close_loading()
      }).catch((err) => {
        this.close_loading()
      });
    },

    // 銀行コードをクリアし、銀行候補を表示する。
    bankInput(val, cb) {
      this.branchName = ''
      this.branchCd = ''
      // 调用 callback 返回建议列表的数据
      cb(this.bankInfo);
    },

    // 银行选择
    bankSelect(item) {
      this.bankCd = item.bankCd
    },

    // 银行input失去焦点
    bankBlur() {
      if (this.bankName) {
        this.bankInfoQuery('blur')
      }
    },

    // 銀行検索
    bankInfoQuery(val) {
      this.bankInfo = []
      this.branchInfo = []
      amsApi.bankInfoGet(this.bankName).then(res => {
        if (res.code == 204) {
          this.bankInfo = res.items.bankInfo
          if (val == 'blur') {
            var exist = false
            for (var item of this.bankInfo) {
              if (item.bankName == this.bankName) {
                exist = true
                this.bankCd =  item.bankCd;
              }
            }
            if (!exist) {
              this.$message.warning({ message: this.$t('COMMON.MSG_NO_BANK'), showClose: true })
              this.bankName = ''
              this.bankCd = ''
              this.branchName = ''
              this.branchCd = ''
            }
          }
        } else if (res.code == '300' && val == 'blur') {
          // 銀行が存在しません。
          this.$message.warning({ message: this.$t('COMMON.MSG_NO_BANK'), showClose: true })
          this.bankName = ''
          this.bankCd = ''
          this.branchName = ''
          this.branchCd = ''
        }
      })
    },

    // 支店コードをクリアし、銀行候補を表示する。
    branchInput(val, cb) {
      // 调用 callback 返回建议列表的数据
      cb(this.branchInfo);
    },

    //  支店选择
    branchSelect(item) {
      this.branchCd = item.branchCd
    },

    //  支店input失去焦点
    branchBlur() {
      if (this.branchName) {
        this.branchInfoQuery('blur')
      }
    },

    //  支店検索
    branchInfoQuery(val) {
      this.branchInfo = []
      amsApi.branchInfoGet(this.bankCd, this.branchName).then(res => {
        if (res.code == 204) {
          this.branchInfo = res.items.branchInfo
          if (val == 'blur') {
            var exist = false
            for (var item of this.branchInfo) {
              if (item.branchName == this.branchName) {
                exist = true
                this.branchCd =  item.branchCd;
              }
            }
            if (!exist) {
              this.$message.warning({ message: this.$t('COMMON.MSG_NO_BRANCH'), showClose: true })
              this.branchName = ''
              this.branchCd = ''
            }
          } else {
              // 支店input 变化监听，先清空branchCd，防止从支店点击“申请”按钮，无法进行check
              this.branchCd = '';
              for (var item of this.branchInfo) {
                if (item.branchName == this.branchName) {
                  this.branchCd =  item.branchCd;
                }
              }
          }
        } else if (res.code == '300' && val == 'blur') {
          // 支店が存在しません。
          this.$message.warning({ message: this.$t('COMMON.MSG_NO_BRANCH'), showClose: true })
          this.branchName = ''
          this.branchCd = ''
        }
      })
    },

    //申請
    apply() {
      if (!this.paramsCheck()) {
        return
      }
      // データを保存します。よろしいでしょうか？
      this.$confirm(this.$t('COMMON.MSG_CONFIRM_CHANGE'), this.$t('COMMON.CONFIRM'), {
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
        customClass: 'i0003textCenter'
      }).then(() => {
        // 画面刷新
        this.save()
      }).catch(() => {
      });
    },

    // 保存数据
    save() {
      amsApi.salaryAccountInfoSave(this.saveParamsGet(), this.userCd).then(res => {
        if (res.code == '202') {
          this.$message.success({ message: this.$t('COMMON.MSG_INSERTED'), showClose: true });//保存成功
          this.salaryAccountInfoQuery()
        } else if (res.code == '311') {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        } else if (res.code == '308') {
          // 処理が失敗しました。他の人が先に更新した可能性があります。最新情報を取得しますか。
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), this.$t('COMMON.CONFIRM'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
            customClass: 'i0003textCenter'
          }).then(() => {
            // 画面刷新
            this.salaryAccountInfoQuery()
          }).catch(() => {
          });
        } else if (res.code == '435') {
          // 既に承認されましたので、処理が失敗しました。最新情報を取得しますか？
          this.$confirm(this.$t('COMMON.MSG_APPROVED'), this.$t('COMMON.CONFIRM'), {
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
            customClass: 'i0003textCenter'
          }).then(() => {
            // 画面刷新
            this.salaryAccountInfoQuery()
          }).catch(() => {
          });
        }
      })
    },

    //申請参数获取
    saveParamsGet() {
      var saveParams = {
        "bankCd": this.bankCd,
        "bankName": this.bankName,
        "branchCd": this.branchCd,
        "branchName": this.branchName,
        "accountDiv": this.accountDiv,
        "accountNo": this.accountNo,
        "holderName": this.holderName,
        "holderKana": this.holderKana,
        "processCd": this.processCd,
        "userCd": this.userCd,
        "updateDate": this.updateDate
      }
      if (saveParams.processCd == '1') {
        saveParams.id = this.id
      }
      return saveParams
    },

    // 必須チェックを行う。
    paramsCheck() {
      //銀行名
      if (this.bankName == '' || this.bankCd == '') {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_BANKNAME')), showClose: true })
        return false
      }

      //支店名
      if (this.branchName == '' || this.branchCd == '') {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_BRANCHNAME')), showClose: true })
        return false
      }

      //口座区分
      if (!this.accountDiv) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_ACCOUNT_CLASSIFICATION')), showClose: true })
        return false
      }

      //口座番号
      if (!this.accountNo) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_ACCOUNT_NUMBER')), showClose: true })
        return false
      }

      //名義人名
      if (!this.holderName) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_NOMINAL_NAME')), showClose: true })
        return false
      }

      //名義人カナ
      if (!this.holderKana) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replace('{1}', this.$t('MODULE.I0003_LBL_NOMINAL_KANA')), showClose: true })
        return false
      }
      return true
    },

    // 口座番号半角数字のみ入力可
    accountNoChange() {
      this.accountNo = this.accountNo.replace(/[^0-9]/ig, "");
    },

    // 名義人カナ半角文字のみ入力可
    holderKanaChange(val) {
      var reg = /[^\uff66-\uff9f^\u0020^a-zA-Z0-9]/g
      this.holderKana = this.holderKana.replace(reg, '')
    },

  },
  watch: {
    bankName: function () {
      this.bankInfoQuery()
    },
    branchName: function () {
      this.branchInfoQuery()
    }
  },
}
</script>
<style >
/* 表格边框、字体样式 */
.i0003-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0003-table,
.i0003-table tr td {
  border: 1px solid #ccc;
}
.i0003-form-value,
.i0003-form-value tr td {
  padding-right: 0 !important;
}
/* 表格内边距 */
.i0003-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0003-form-label {
  text-align: right;
  width: 110px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0003-form-value {
  background: #fafafa;
}
ul.decimal {
  list-style-type: decimal;
  padding-inline-start: 25px;
}

.i0003-input {
  width: 94%;
}

.i0003-css-btn {
  color: #fff;
  margin-top: 15px;
  width: 100px;
  height: 40px;
  padding-top: 10px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0003-css-btn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}

/*按钮激活和焦点样式*/
.i0003-css-btn:active,
.i0003-css-btn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
.i0003textCenter .el-message-box__btns {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0003.vue